export default {
    data(){
      return {
          paginationOptions: [
              {
                  label: '10',
                  value: 10
              },
              {
                  label: '15',
                  value: 15
              },
              {
                  label: '25',
                  value: 25
              },
              {
                  label: '50',
                  value: 50
              },
              {
                  label: '100',
                  value: 100
              },
              {
                  label: '200',
                  value: 200
              },
              {
                  label: '500',
                  value: 500
              },
              {
                  label: '1000',
                  value: 1000
              }
          ]
      }
    },
    methods: {
        onChangePagination(newValue) {
            this.$store.dispatch(this.namespace + '/startLoading');
            this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);
            this.$store.dispatch(this.namespace + '/setReportPaginationFilter', newValue);
            this.$store.dispatch(this.namespace + '/clearPagination');

            this.previousPageCursor = null;
            this.nextPageCursor = null;

            this.$store.dispatch(this.namespace + '/setCurrentRowsCount', null);
        },
        previousPage(){
            this.$store.dispatch(this.namespace + '/setPagination', {cursor: this.$store.getters[this.namespace + '/getPageInfoPreviousCursor'], direction: 'before'});
            this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);

            this.previousPageCursor = null;
            this.nextPageCursor = this.$store.getters[this.namespace + '/getPageInfoPreviousCursor'];

            this.$store.dispatch(this.namespace + '/startLoading');
            this.$store.dispatch(this.namespace + '/setCurrentRowsCount', this.currentRows - this.$store.getters[this.namespace + '/getPaginationLimit']);
        },
        nextPage(){
            this.$store.dispatch(this.namespace + '/setPagination', {cursor: this.$store.getters[this.namespace + '/getPageInfoNextCursor'], direction: 'after'});
            this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);

            this.previousPageCursor = this.$store.getters[this.namespace + '/getPageInfoNextCursor'];
            this.nextPageCursor = null;

            this.$store.dispatch(this.namespace + '/startLoading');
            this.$store.dispatch(this.namespace + '/setCurrentRowsCount', this.currentRows + this.$store.getters[this.namespace + '/getPaginationLimit']);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table/paginationMixin.js